import { useState } from "react";
import { motion } from "framer-motion";
import { ScrollText, FileText, CheckCircle2, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fileUrl } from "@/lib/upload";

const GATE_INITIAL = { opacity: 0, y: 20 };
const GATE_ANIMATE = { opacity: 1, y: 0 };
import { ContactLinks, hasPrivacy } from "@/components/ContestRules";

export const contestHasRules = (c) => !!(c?.rules_text || c?.rules_file_id);
const lsKey = (id) => `vw_rules_ok_${id}`;
export const rulesAcceptedLocally = (id, version = 1) => {
  const v = localStorage.getItem(lsKey(id));
  if (!v) return false;
  const m = v.match(/^v(\d+)\|/);
  return (m ? parseInt(m[1], 10) : 1) === (version || 1);
};
export const rememberRulesAccepted = (id, version = 1) => localStorage.setItem(lsKey(id), `v${version || 1}|${new Date().toISOString()}`);

export const RulesAcceptGate = ({ contest, onAccept, updated = false }) => {
  const [checked, setChecked] = useState(false);
  return (
    <motion.div initial={GATE_INITIAL} animate={GATE_ANIMATE} className="rounded-3xl bg-white/95 text-slate-900 p-6 sm:p-8 shadow-2xl space-y-4" data-testid="rules-accept-gate">
      <div className="flex items-center gap-3">
        <span className="h-11 w-11 rounded-xl bg-amber-100 grid place-items-center"><ScrollText className="h-6 w-6 text-amber-600" /></span>
        <div><h2 className="font-display font-bold text-xl">{updated ? "Il regolamento è stato aggiornato" : "Regolamento del concorso"}</h2><p className="text-sm text-slate-500">{updated ? `Nuova versione ${contest.rules_version}: rileggi e accetta il regolamento aggiornato per continuare.` : "Prima di giocare leggi e accetta il regolamento. Ti verrà chiesto una sola volta."}</p></div>
      </div>
      {contest.rules_file_id && (
        <a href={fileUrl(contest.rules_file_id)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-700 underline" data-testid="rules-gate-pdf"><FileText className="h-4 w-4" /> Apri il regolamento (PDF)</a>
      )}
      {contest.rules_text && <div className="max-h-48 overflow-y-auto rounded-xl bg-slate-100 p-4 text-sm whitespace-pre-wrap" data-testid="rules-gate-text">{contest.rules_text}</div>}
      {hasPrivacy(contest) && (
        <a href={`/privacy/${contest.id}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-sm font-medium text-blue-700 underline" data-testid="rules-gate-privacy"><ShieldCheck className="h-4 w-4" /> Leggi l'informativa privacy</a>
      )}
      <ContactLinks c={contest} />
      <label className="flex items-start gap-3 cursor-pointer text-sm" data-testid="rules-gate-label">
        <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} className="mt-0.5 h-5 w-5 accent-blue-600" data-testid="rules-gate-checkbox" />
        <span>Ho letto e <b>accetto il regolamento</b>{hasPrivacy(contest) ? <> e <b>l'informativa privacy</b></> : null} del concorso <b>{contest.name}</b>{contest.rules_version > 1 ? <span className="text-slate-400"> (versione {contest.rules_version})</span> : null}</span>
      </label>
      <Button data-testid="rules-gate-accept" disabled={!checked} onClick={onAccept} className="w-full h-12 gap-2 text-base"><CheckCircle2 className="h-5 w-5" /> Accetto e continuo</Button>
    </motion.div>
  );
};
